/**
 * Gift Video Teaser – Modal + Slide-Up Panel Controller
 * v3 – kein separates Dim-Element, alles über Modal-Container
 */

class GiftVideoTeaser {
  constructor(sectionId) {
    this.id      = sectionId;
    this.modal   = document.getElementById('gvt-modal-' + sectionId);
    this.video   = document.getElementById('gvt-video-' + sectionId);
    this.overlay = this.modal ? this.modal.querySelector('.gvt-video__play-overlay') : null;

    if (!this.modal || !this.video) return;

    this._bindOpen();
    this._bindClose();
    this._bindVideo();
    this._blockHorizontalSwipe();
  }

  isMobile() {
    return window.innerWidth <= 768;
  }

  /* ── Open ───────────────────────────────────────────────── */
  _bindOpen() {
    var self = this;
    var btns = document.querySelectorAll('[data-gvt-open="' + this.id + '"]');
    btns.forEach(function(btn) {
      btn.addEventListener('click', function() { self.open(); });
    });
  }

  open() {
    var self = this;

    // Header-Höhe live auslesen
    var headerEl = document.querySelector('[data-header-height]');
    var headerH = headerEl ? headerEl.getBoundingClientRect().bottom : 0;

    this.modal.removeAttribute('hidden');

    // Mobile: Panel direkt unter Header positionieren
    if (window.innerWidth <= 768) {
      this.modal.style.top    = headerH + 'px';
      this.modal.style.height = 'calc(100dvh - ' + headerH + 'px)';
    }

    // reflow erzwingen
    void this.modal.offsetHeight;

    setTimeout(function() {
      self.modal.classList.add('is-open');
    }, 16);

    document.body.style.overflow = 'hidden';
  }

  /* ── Close ──────────────────────────────────────────────── */
  _bindClose() {
    var self = this;

    // Backdrop-Klick (auf Modal-Container selbst, nicht auf Dialog)
    this.modal.addEventListener('click', function(e) {
      if (e.target === self.modal || e.target.hasAttribute('data-gvt-close')) {
        self.close();
      }
    });

    // Close-Button explizit
    var closeBtn = this.modal.querySelector('.gvt-modal__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        self.close();
      });
    }

    // Overlay (Desktop)
    var overlay = this.modal.querySelector('.gvt-modal__overlay');
    if (overlay) {
      overlay.addEventListener('click', function(e) {
        e.stopPropagation();
        self.close();
      });
    }

    // Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && self.modal.classList.contains('is-open')) {
        self.close();
      }
    });
  }

  close() {
    var self = this;
    this.video.pause();
    this.video.currentTime = 0;
    this._showPlayOverlay();

    this.modal.classList.remove('is-open');
    document.body.style.overflow = '';

    setTimeout(function() {
      self.modal.setAttribute('hidden', '');
      // Inline-Styles zurücksetzen
      self.modal.style.top    = '';
      self.modal.style.height = '';
    }, 420);
  }

  /* ── Video Controls ─────────────────────────────────────── */
  _bindVideo() {
    var self = this;

    if (this.overlay) {
      this.overlay.addEventListener('click', function(e) {
        e.stopPropagation();
        self.video.play().catch(function() {});
      });
    }

    this.video.addEventListener('play', function() { self._hidePlayOverlay(); });
    this.video.addEventListener('pause', function() {
      if (!self.video.ended) self._showPlayOverlay();
    });
    this.video.addEventListener('ended', function() { self._showPlayOverlay(); });

    this.video.addEventListener('click', function(e) {
      e.stopPropagation();
      if (self.video.paused) {
        self.video.play().catch(function() {});
      } else {
        self.video.pause();
      }
    });
  }

  _hidePlayOverlay() {
    if (this.overlay) this.overlay.classList.add('is-hidden');
  }
  _showPlayOverlay() {
    if (this.overlay) this.overlay.classList.remove('is-hidden');
  }

  /* Horizontales Swipen blockieren (iOS Flickity-Konflikt) */
  _blockHorizontalSwipe() {
    var dialog = this.modal.querySelector('.gvt-modal__dialog');
    if (!dialog) return;
    var startX = 0;
    var startY = 0;
    dialog.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    dialog.addEventListener('touchmove', function(e) {
      var dx = Math.abs(e.touches[0].clientX - startX);
      var dy = Math.abs(e.touches[0].clientY - startY);
      if (dx > dy) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, { passive: false });
  }

  destroy() {
    this.close();
  }
}

/* ── Init ───────────────────────────────────────────────── */
function initGiftVideoTeasers() {
  var sections = document.querySelectorAll('.gvt-section');
  sections.forEach(function(el) {
    var id = el.dataset.sectionId;
    if (id && !el._gvtInit) {
      el._gvtInit = new GiftVideoTeaser(id);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGiftVideoTeasers);
} else {
  initGiftVideoTeasers();
}

/* ── Shopify Theme Editor ───────────────────────────────── */
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(e) {
    var el = e.target.querySelector('.gvt-section');
    if (el) el._gvtInit = new GiftVideoTeaser(el.dataset.sectionId);
  });
  document.addEventListener('shopify:section:unload', function(e) {
    var el = e.target.querySelector('.gvt-section');
    if (el && el._gvtInit) el._gvtInit.destroy();
  });
}